import Page from '../../components/page/Page'
import { useNavigate } from "react-router-dom"
import s from "./Rules.module.scss"

export default function Rules() {
  const nav = useNavigate()

  return (
    <Page>
      <h1>Rules Summary</h1>

      <div className={s.content}>
        <span>This page outlines briefly the 10 rules of the server. Click on a rule to see a more in-depth explanation.</span>

        <span>Most punishments for breaking the rules are listed in our <span className="link" onClick={() => nav("/docs/policies")}>Policies Document</span>.</span>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/1")}>Rule 1 - Be Nice</h4>

          <span>Don't insult, bully, harass, scam, socially manipulate, or impersonate other players and don't use offensive or excessively vulgar language.</span>
        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/2")}>Rule 2 - Don't Grief</h4>

          <span>Don't grief, steal from, or attack other players.</span>
        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/3")}>Rule 3 - Don't Cheat</h4>

          <span>Don't hack or use mods that gives you a significant advantage.</span>
        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/4")}>Rule 4 - Keep it PG-13</h4>

          <span>Don't create, spread or promote extreme examples of non-child friendly content, including references to hard drugs, sex, or child abuse.</span>
        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/5")}>Rule 5 - No AFK Farming</h4>

          <span>Don't go AFK next to a farm, use a chunk loader, or attempt to bypass the 20-minute AFK kick in any way, including coming back once in a while to move around jump, etc.</span>
        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/6")}>Rule 6 - Respect the Chat</h4>

          <span>Don't spam, flood the chat with lots of messages at once, advertise anything not related to our server in any server chats, speak languages other than English in global chat, or beg for items or money.</span>
        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/7")}>Rule 7 - Respect Staff Members</h4>

          <span>Don't disrespect staff members, make active efforts to prevent them from enforcing the rules, or misuse the /helpop command. Comply with all reasonable requests they make in effort to enforce the rules, regardless of if you agree with what they say or not.</span>
        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/8")}>Rule 8 - No Profiteering</h4>

          <span>- Don't sell in-game items for real money or items from the webstore.</span>

          <span>- Don't use an alt account to bypass limitations such as dynamic /shop pricing or the jobs income limit.</span>

          <span>- Don't repeatedly change shop prices to undercut another player and don't buy items from someone to resell them at a higher price or to eliminate competition. If in doubt, refer to rule 1.</span>

          <span>- Don't deliberately clutter /ah with listings that nobody will buy.</span>

          <span>- Don't make a profit using other players' creative works without permission.</span>

        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/9")}>Rule 9 - Don't Exploit</h4>

          <span>Don't abuse bugs, glitches, exploits, or mishaps in /shop pricing and alert a staff member if you discover one.</span>
        </div>

        <div className={s.rule}>
          <h4 onClick={() => nav("/rules/10")}>Rule 10 - Be a Good Citizen</h4>

          <span>Don't start a build within 10 chunks of someone else's without their permission and follow the rules and guidelines specified in the <span className="link" onClick={() => nav("/docs/townhandbook")}>Town Handbook</span>.</span>
        </div>
      </div>
    </Page>
  )
}
